const types = {
    SET_GET_STATISTICS: '[STATISTICS] SET GET STATISTICS',
}

export {
    types,
}